const defaultState = { text: null, type: null, action: null, countdown: null }

const set = (message, type, action, countdown) => ({ text: message, type, action, countdown })
const clear = () => defaultState
const hasMessageToDisplay = (state) => !!(state.type && state.text)

const messageState = { defaultState, set, clear, hasMessageToDisplay }
export default messageState
